module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_8004.8174c7a3.png";